export const LOAD_PRODUCTS = 'load_products';
export const PRODUCTS_LOADED = 'set_loaded_products';
export const RESET_PRODUCTS = 'reset_products';
export const SYNC_FAILED = 'products_sync_error';
export const LOAD_SUBGROUPS = 'load_subgroups';
export const SUBGROUPS_LOADED = 'set_loaded_subgroups';
export const RESET_SUBGROUPS = 'reset_subgroups';
export const SUBGROUPS_SYNC_FAILED = 'subgroups_sync_error';
export const LOAD_VIRTUAL_PACKS = 'load_virtual_packs';
export const VIRTUAL_PACKS_LOADED = 'virtual_packs_loaded';
export const VIRTUAL_PACKS_SYNC_FAILED = 'virtual_packs_sync_failed';
export const RESET_VIRTUAL_PACKS = 'reset_virtual_packs';
